// extracted by mini-css-extract-plugin
export default {"container":"EditUserModal_container__OSwqg","error__text":"EditUserModal_error__text__L7lMk","error__icon":"EditUserModal_error__icon__7+YK3"};